module.exports = __webpack_public_path__ + "static/img/strong_8.79abe6b8.png";